/**
 * @generated SignedSource<<a9a049234e15f0f1372bc83abad16d60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectUpdateInput = {
  client_id?: number | null | undefined;
  client_name?: string | null | undefined;
  confirmed: boolean;
  custom_values?: ProjectInputCustomValues | null | undefined;
  emoji?: string | null | undefined;
  is_template: boolean;
  links?: ReadonlyArray<ProjectInputLink> | null | undefined;
  manager_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  name: string;
  pricing_model: string;
  project_id: number;
  rate_card_id: number;
  references?: any | null | undefined;
  tags?: ReadonlyArray<string | null | undefined> | null | undefined;
  team_id?: number | null | undefined;
  workstreams?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type ProjectInputCustomValues = {
  checkbox?: ReadonlyArray<ProjectInputCustomValuesCheckbox | null | undefined> | null | undefined;
  date?: ReadonlyArray<ProjectInputCustomValuesDate | null | undefined> | null | undefined;
  select?: ReadonlyArray<ProjectInputCustomValuesSelect | null | undefined> | null | undefined;
  text?: ReadonlyArray<ProjectInputCustomValuesText | null | undefined> | null | undefined;
};
export type ProjectInputCustomValuesCheckbox = {
  typeId: number;
  value: boolean;
};
export type ProjectInputCustomValuesDate = {
  typeId: number;
  value?: string | null | undefined;
};
export type ProjectInputCustomValuesSelect = {
  optionId: number;
  typeId: number;
};
export type ProjectInputCustomValuesText = {
  typeId: number;
  value: string;
};
export type ProjectInputLink = {
  href: string;
  id?: number | null | undefined;
  name: string;
  show_in_planner: boolean;
};
export type ProjectUpdateMutation$variables = {
  input: ProjectUpdateInput;
};
export type ProjectUpdateMutation$data = {
  readonly action_project_update: {
    readonly account: {
      readonly clients: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly id: number;
      readonly project_tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly workstreams: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly project: {
      readonly active: boolean;
      readonly assignments: ReadonlyArray<{
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly is_billable: boolean | null | undefined;
        readonly minutes_per_day: number;
        readonly non_working_day: boolean;
        readonly note: string | null | undefined;
        readonly person_id: number;
        readonly phase_id: number | null | undefined;
        readonly project_id: number;
        readonly role_id: number;
        readonly start_date: string | null | undefined;
        readonly updated_at: string;
        readonly workstream_id: number | null | undefined;
      }>;
      readonly client: {
        readonly active: boolean;
        readonly id: number;
        readonly image_key: string | null | undefined;
        readonly internal: boolean | null | undefined;
        readonly name: string;
        readonly real_client: boolean | null | undefined;
        readonly website: string | null | undefined;
      };
      readonly client_id: number;
      readonly confirmed: boolean;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly emoji: string | null | undefined;
      readonly id: number;
      readonly is_template: boolean;
      readonly links: ReadonlyArray<{
        readonly href: string;
        readonly id: number;
        readonly name: string;
        readonly show_in_planner: boolean;
      }>;
      readonly managers: ReadonlyArray<{
        readonly id: number;
        readonly project: {
          readonly id: number;
        };
        readonly user_id: number;
      }>;
      readonly name: string;
      readonly pricing_model: string;
      readonly pricing_model_readable: string | null | undefined;
      readonly priority: string | null | undefined;
      readonly project_workstreams: ReadonlyArray<{
        readonly workstream: {
          readonly archived: boolean;
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly rate_card: {
        readonly id: number;
        readonly role_charge_out_rates: ReadonlyArray<{
          readonly charge_out_rate: number | null | undefined;
          readonly rate_card_id: number;
          readonly role_id: number;
        }>;
      };
      readonly rate_card_id: number;
      readonly references: any;
      readonly tags: any | null | undefined;
      readonly team: {
        readonly id: number;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly total_budget: number | null | undefined;
      readonly workstreams_computed: any | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupStats_project">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectUpdateMutation = {
  response: ProjectUpdateMutation$data;
  variables: ProjectUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "client_id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate_card_id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmed",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_template",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricing_model_readable",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstreams_computed",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emoji",
  "storageKey": null
},
v17 = {
  "alias": "total_budget",
  "args": null,
  "kind": "ScalarField",
  "name": "total_budget_private",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "clients",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image_key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "real_client",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "rate_cards",
  "kind": "LinkedField",
  "name": "rate_card",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "role_charge_out_rates",
      "kind": "LinkedField",
      "name": "role_charge_out_rates",
      "plural": true,
      "selections": [
        (v19/*: any*/),
        (v7/*: any*/),
        {
          "alias": "charge_out_rate",
          "args": null,
          "kind": "ScalarField",
          "name": "charge_out_rate_private",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  (v2/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "project_managers",
  "kind": "LinkedField",
  "name": "managers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "user_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v21/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workstream_id",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "assignments",
  "kind": "LinkedField",
  "name": "assignments",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "person_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "project_id",
      "storageKey": null
    },
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase_id",
      "storageKey": null
    },
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note",
      "storageKey": null
    },
    {
      "alias": "start_date",
      "args": null,
      "kind": "ScalarField",
      "name": "start_date_runn",
      "storageKey": null
    },
    {
      "alias": "end_date",
      "args": null,
      "kind": "ScalarField",
      "name": "end_date_runn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minutes_per_day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_billable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "non_working_day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updated_at",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v27 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v26/*: any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "project_workstreams",
  "kind": "LinkedField",
  "name": "project_workstreams",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "workstreams",
      "kind": "LinkedField",
      "name": "workstream",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "project_links",
  "kind": "LinkedField",
  "name": "links",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "show_in_planner",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_select_values",
  "kind": "LinkedField",
  "name": "custom_select_values",
  "plural": true,
  "selections": [
    {
      "alias": "optionId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_option_id",
      "storageKey": null
    },
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v30/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "model",
    "storageKey": null
  },
  (v26/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "accounts",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "clients",
      "kind": "LinkedField",
      "name": "clients",
      "plural": true,
      "selections": (v21/*: any*/),
      "storageKey": null
    },
    {
      "alias": "project_tags",
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "model": {
              "_eq": "project"
            }
          }
        }
      ],
      "concreteType": "tags",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": "tags(where:{\"model\":{\"_eq\":\"project\"}})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "tags",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": (v35/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "workstreams",
      "kind": "LinkedField",
      "name": "workstreams",
      "plural": true,
      "selections": (v27/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectUpdateOutput",
        "kind": "LinkedField",
        "name": "action_project_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectGroupStats_project"
              }
            ],
            "storageKey": null
          },
          (v36/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProjectUpdateOutput",
        "kind": "LinkedField",
        "name": "action_project_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "projects",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "accounts",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "default_full_time_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "v_summary_total",
                "kind": "LinkedField",
                "name": "summary",
                "plural": true,
                "selections": [
                  (v19/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_billable_minutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total_nonbillable_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_roles",
                "kind": "LinkedField",
                "name": "project_roles",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimated_minutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "project_rates",
                "kind": "LinkedField",
                "name": "project_rates",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": "rate",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rate_private",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v36/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e19955a86bc3f062e5e42d7e9ecabb5",
    "id": null,
    "metadata": {},
    "name": "ProjectUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectUpdateMutation(\n  $input: ProjectUpdateInput!\n) {\n  action_project_update(input: $input) {\n    project {\n      id\n      name\n      active\n      references\n      client_id\n      rate_card_id\n      team_id\n      confirmed\n      is_template\n      pricing_model\n      pricing_model_readable\n      tags\n      workstreams_computed\n      priority\n      emoji\n      total_budget: total_budget_private\n      client {\n        id\n        active\n        name\n        image_key\n        internal\n        website\n        real_client\n      }\n      rate_card {\n        id\n        role_charge_out_rates {\n          role_id\n          rate_card_id\n          charge_out_rate: charge_out_rate_private\n        }\n      }\n      team {\n        id\n      }\n      managers {\n        id\n        user_id\n        project {\n          id\n        }\n      }\n      assignments {\n        id\n        person_id\n        project_id\n        role_id\n        phase_id\n        workstream_id\n        note\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        is_billable\n        non_working_day\n        updated_at\n      }\n      project_workstreams {\n        workstream {\n          id\n          name\n          archived\n        }\n      }\n      links {\n        id\n        name\n        href\n        show_in_planner\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n      ...ProjectGroupStats_project\n    }\n    account {\n      id\n      clients {\n        id\n      }\n      project_tags: tags(where: {model: {_eq: \"project\"}}) {\n        id\n        name\n        model\n        archived\n      }\n      tags {\n        id\n        name\n        model\n        archived\n      }\n      workstreams {\n        id\n        name\n        archived\n      }\n    }\n  }\n}\n\nfragment ProjectGroupStats_project on projects {\n  id\n  is_template\n  pricing_model\n  account {\n    id\n    default_full_time_minutes\n  }\n  client {\n    id\n    internal\n  }\n  summary {\n    role_id\n    workstream_id\n    total_billable_minutes\n    total_nonbillable_minutes\n  }\n  project_roles {\n    id\n    role_id\n    estimated_minutes\n  }\n  project_rates {\n    id\n    role_id\n    rate: rate_private\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed1829c7465e628dea9fe21d320acc55";

export default node;
